<div class="search-group-field-container">
    <div class="search">
        <div class="group-dropdown" tabindex="1" id="groupDrop">
            <mat-accordion #expansionTeam="matAccordion">
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            {{grpSelect?.name ? grpSelect?.name : placeholder}}
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <ng-container [ngTemplateOutlet]="menuTemplate"></ng-container>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
    </div>
</div>


<ng-template #menuTemplate>
    <div class="group-menu-container">
        <div class="group-content" (click)="$event.stopPropagation()">
            <span *ngIf="indicatorString">({{indicatorString}})</span>
            <div class="tree-content">
                <mat-tree [dataSource]="infoGrpList" [treeControl]="treeControl">
                    <!-- This is the tree node template for leaf nodes -->
                    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
                        <div class="vertical-line"
                            *ngIf="(!node.last && !node.lastParent) || (node.last && !node.lastParent)">
                        </div>
                        <!-- use a disabled button to provide padding for tree leaf -->
                        <div *ngIf="!node.grpcd" matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name"
                            class="tree-item not-child">
                            <span>{{node.name}}</span>
                        </div>
                        <!-- [class.active]="teamSelect.teamcd === node.teamcd" -->
                        <div *ngIf="node.grpcd" matTreeNodeToggle [class.last-item]="node.last"
                            [attr.aria-label]="'Toggle ' + node.name" class="tree-item child"
                            [class.active]="grpSelect?.grpunit === node.grpunit" (click)="onGroupTeam(node)">
                            <span>{{node.name}}</span>
                        </div>
                    </mat-tree-node>
                    <!-- This is the tree node template for expandable nodes -->
                    <mat-tree-node *matTreeNodeDef="let node;when: hasChild; let i = index" matTreeNodePadding>
                        <div class="vertical-line" [class.half]="node.last"></div>
                        <div matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name" class="tree-item parent">
                            <i [ngClass]="treeControl.isExpanded(node) ? 'minus-expand-icon' : 'expand-icon'"></i>
                            <span>{{node.name}}</span>
                        </div>
                    </mat-tree-node>
                </mat-tree>
            </div>
        </div>
    </div>
</ng-template>